module.exports = __webpack_public_path__ + "static/media/comic2010.4559b45b.png";